import { CustomNavBar } from 'components/facets/CustomNavBar/CustomNavBar'
import { useUser } from 'components/providers/UserProvider'
import { useAppContext } from 'lib/hooks'
import qs from 'query-string'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { AllExports } from './AllExports'
import './exports-presenter.css'
import { InventoryExports } from './InventoryExports'
import { OrdersExports } from './OrdersExports'
import { TaxationExports } from './TaxationExports'
import { TransactionsExports } from './TransactionsExports'

export type ExportsSidebarTab = 'all' | 'taxation' | 'inventory' | 'orders' | 'transactions'

export const ExportsPresenter = (): JSX.Element => {
  const { t } = useTranslation()
  const { user } = useUser()
  const { isMobile } = useAppContext()

  const { search } = useLocation()
  const query = qs.parse(search)
  const initialTab = (
    ['all', 'taxation', 'inventory', 'orders', 'transactions'].includes(query.tab as string)
      ? query.tab
      : 'all'
  ) as ExportsSidebarTab
  const [activeTab, setActiveTab] = useState<ExportsSidebarTab>(initialTab)

  const tabs = [
    { key: 'all', label: t('exports.tabs.all'), dataTestid: 'exports-all' },
    ...(user?.featureFlags?.taxation
      ? [{ key: 'taxation', label: t('exports.tabs.taxation'), dataTestid: 'exports-taxation' }]
      : []),
    { key: 'inventory', label: t('exports.tabs.inventory'), dataTestid: 'exports-inventory' },
    { key: 'orders', label: t('exports.tabs.orders'), dataTestid: 'exports-orders' },
    {
      key: 'transactions',
      label: t('exports.tabs.transactions'),
      dataTestid: 'exports-transactions',
    },
  ]

  const renderContent = () => {
    switch (activeTab) {
      case 'taxation':
        return <TaxationExports />
      case 'inventory':
        return <InventoryExports />
      case 'orders':
        return <OrdersExports />
      case 'transactions':
        return <TransactionsExports />
      default:
        return <AllExports />
    }
  }

  return (
    <div className={`w-100 mt-3 ${isMobile ? '' : 'ms-3'}`}>
      <CustomNavBar
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={(key) => setActiveTab(key as ExportsSidebarTab)}
      />
      {renderContent()}
    </div>
  )
}
